import Icon from './ui/Icon';
import Reveal from './ui/Reveal';
import { curriculum } from '../data/content';

export default function Curriculum() {
  return (
    <section id="curriculum">
      <div className="wrap narrow">
        <Reveal className="center">
          <span className="eyebrow">The curriculum</span>
          <h2 className="h-sec">What&rsquo;s actually in the program?</h2>
          <p className="lede mt-m">
            Six weeks of structured, live coaching. Each topic builds on the last — here&rsquo;s how
            it unfolds.
          </p>
        </Reveal>

        <Reveal className="acc mt-l" delay={1}>
          {curriculum.map((week, i) => (
            <details key={week.title} open={i === 0}>
              <summary>
                <span className="em">
                  <Icon name={week.icon} />
                </span>
                <span className="t">{week.title}</span>
                <span className="plus" aria-hidden="true">
                  +
                </span>
              </summary>
              <div className="body">{week.body}</div>
            </details>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
